import { useTranslation } from 'react-i18next';
import { LegalPage, LegalSection } from '@/components/shared/LegalPage';

/**
 * Politique de confidentialité — page publique standard.
 *
 * Contenu placeholder à remplacer par un texte rédigé par un juriste avant
 * la mise en production grand public. Suffisant pour la verification
 * Google OAuth (qui exige juste qu'une URL retourne un texte cohérent).
 */
export default function PrivacyPolicy() {
  const { t } = useTranslation(['pages']);
  const s2Items = t('pages:legal.privacyPolicy.s2.items', { returnObjects: true }) as unknown as string[];
  const s3Items = t('pages:legal.privacyPolicy.s3.items', { returnObjects: true }) as unknown as string[];
  const s6Items = t('pages:legal.privacyPolicy.s6.items', { returnObjects: true }) as unknown as string[];

  const sections = [
    { id: 's1', heading: t('pages:legal.privacyPolicy.s1.heading') },
    { id: 's2', heading: t('pages:legal.privacyPolicy.s2.heading') },
    { id: 's3', heading: t('pages:legal.privacyPolicy.s3.heading') },
    { id: 's4', heading: t('pages:legal.privacyPolicy.s4.heading') },
    { id: 's5', heading: t('pages:legal.privacyPolicy.s5.heading') },
    { id: 's6', heading: t('pages:legal.privacyPolicy.s6.heading') },
    { id: 's7', heading: t('pages:legal.privacyPolicy.s7.heading') },
    { id: 's8', heading: t('pages:legal.privacyPolicy.s8.heading') },
    { id: 's9', heading: t('pages:legal.privacyPolicy.s9.heading') },
    { id: 's10', heading: t('pages:legal.privacyPolicy.s10.heading') },
  ];

  return (
    <LegalPage
      title={t('pages:legal.privacyPolicy.title')}
      lastUpdated={t('pages:legal.privacyPolicy.lastUpdated')}
      sections={sections}
      related={{ to: '/cgu', label: t('pages:legal.privacyPolicy.termsLink') }}
    >
      <LegalSection id="s1" heading={t('pages:legal.privacyPolicy.s1.heading')}>
        <p>
          {t('pages:legal.privacyPolicy.s1.body')}
        </p>
      </LegalSection>

      <LegalSection id="s2" heading={t('pages:legal.privacyPolicy.s2.heading')}>
        <p>{t('pages:legal.privacyPolicy.s2.intro')}</p>
        <ul >
          {s2Items.map((item, idx) => <li key={idx}>{item}</li>)}
        </ul>
      </LegalSection>

      <LegalSection id="s3" heading={t('pages:legal.privacyPolicy.s3.heading')}>
        <p>{t('pages:legal.privacyPolicy.s3.intro')}</p>
        <ul >
          {s3Items.map((item, idx) => <li key={idx}>{item}</li>)}
        </ul>
        <p>
          {t('pages:legal.privacyPolicy.s3.neverPrefix')} <strong>{t('pages:legal.privacyPolicy.s3.neverBold')}</strong>{' '}
          {t('pages:legal.privacyPolicy.s3.neverSuffix')}
        </p>
      </LegalSection>

      <LegalSection id="s4" heading={t('pages:legal.privacyPolicy.s4.heading')}>
        <p>
          {t('pages:legal.privacyPolicy.s4.body')}
        </p>
      </LegalSection>

      <LegalSection id="s5" heading={t('pages:legal.privacyPolicy.s5.heading')}>
        <p>
          {t('pages:legal.privacyPolicy.s5.body')}
        </p>
      </LegalSection>

      <LegalSection id="s6" heading={t('pages:legal.privacyPolicy.s6.heading')}>
        <p>{t('pages:legal.privacyPolicy.s6.intro')}</p>
        <ul >
          {s6Items.map((item, idx) => <li key={idx}>{item}</li>)}
          <li>
            {t('pages:legal.privacyPolicy.s6.cnilPrefix')}
            <a href="https://www.cnil.fr/" target="_blank" rel="noreferrer">www.cnil.fr</a>
            {t('pages:legal.privacyPolicy.s6.cnilSuffix')}
          </li>
        </ul>
        <p>
          {t('pages:legal.privacyPolicy.s6.contactPrefix')}{' '}
          <a href="mailto:contact@revcall.com">contact@revcall.com</a>
          {t('pages:legal.privacyPolicy.s6.contactSuffix')}
        </p>
      </LegalSection>

      <LegalSection id="s7" heading={t('pages:legal.privacyPolicy.s7.heading')}>
        <p>
          {t('pages:legal.privacyPolicy.s7.body')}
        </p>
      </LegalSection>

      <LegalSection id="s8" heading={t('pages:legal.privacyPolicy.s8.heading')}>
        <p>
          {t('pages:legal.privacyPolicy.s8.body')}
        </p>
      </LegalSection>

      <LegalSection id="s9" heading={t('pages:legal.privacyPolicy.s9.heading')}>
        <p>
          {t('pages:legal.privacyPolicy.s9.body')}
        </p>
      </LegalSection>

      <LegalSection id="s10" heading={t('pages:legal.privacyPolicy.s10.heading')}>
        <p>
          {t('pages:legal.privacyPolicy.s10.intro')}
          {' '}<a href="mailto:contact@revcall.com">contact@revcall.com</a>.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
